import { Spacing } from '@persona-id/design-tokens';
import { VFC } from 'react';
import styled from 'styled-components';

import useWorkflowError from 'dashboard/components/WorkflowControlPanel/useWorkflowError';
import { WorkflowError } from 'dashboard/models/workflow';
import { WorkflowRunStepConditional } from 'dashboard/models/workflow-step';
import { WorkflowElse } from 'dashboard/models/workflow-version';
import Spacer from 'design-system/components/Spacer';
import Sticker from 'design-system/components/Sticker';
import { Heading, Paragraph } from 'design-system/components/Text';

const StyledSection = styled.section<{ fullOpacity: boolean }>`
  opacity: ${({ fullOpacity }) => (fullOpacity ? '1' : '0.4')};
`;

const ElseHeading = styled(Heading)`
  margin-right: ${Spacing[2]};
`;

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

interface ElseSectionProps {
  conditional: WorkflowElse;
  errors: WorkflowError[];
  workflowRunStep?: WorkflowRunStepConditional;
  index: number;
}

const ElseSection: VFC<ElseSectionProps> = ({ conditional, errors, workflowRunStep, index }) => {
  const chosenRoute = workflowRunStep?.attributes?.['chosen-conditional-index'];
  const { renderErrorMessageFor } = useWorkflowError(errors);

  return (
    <StyledSection
      data-test='else-section'
      fullOpacity={workflowRunStep ? chosenRoute === index : true}
    >
      <Spacer height={1} />
      <HeadingContainer>
        <ElseHeading size='sm'>{conditional.name}</ElseHeading>
        {workflowRunStep && chosenRoute === index && <Sticker variant='primary'>Match</Sticker>}
      </HeadingContainer>
      <Spacer height={1} />
      <Paragraph size='sm'>
        Follow this route if none of the configured conditions are met.
      </Paragraph>
      {renderErrorMessageFor(`branches[${index}]`)}
    </StyledSection>
  );
};

export default ElseSection;
